import axios from 'axios';

export const login = ({ commit }, data) => new Promise((resolve, reject) => {
  commit('auth_request');
  console.log('login action');
  axios({
    url: '/users/authenticate',
    data,
    method: 'POST',
  })
    .then((resp) => {
      console.log('then');
      const { user } = resp.data;
      const { token } = resp.data;
      axios.defaults.headers.common.Authorization = token;
      commit('auth_success', { user, token });
      // fetch organization list and store the first organization in Vuex
      axios.get('/admin_organizations')
        .then((orgResp) => {
          const orgData = orgResp.data && orgResp.data.length ? orgResp.data[0] : null;
          commit('storeOrganization', orgData);
        })
        .catch(() => {});
      resolve(resp);
    })
    .catch((err) => {
      console.log('catch');
      localStorage.removeItem('token');
      reject(err);
    });
});
// export const setClientEnv = ({ commit }, clientEnv) => {
//   return new Promise((resolve) => {
//     commit('set_client_env', clientEnv);
//     resolve();
//   });
// };

export const logout = ({ commit }) => new Promise((resolve) => {
  commit('logout');
  localStorage.removeItem('token');
  delete axios.defaults.headers.common.Authorization;
  resolve();
});

export default {
  login,
  logout,
};
